import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import IconsLibrary from '../Icon/IconsLibrary';
import OnBoardingWizard from './../Views/Onboarding/OnBoardingWizard';
import OnBoardingWizardVirtalMembers from './../Views/OnboardingVirtualMembers/OnBoardingWizardVirtualMember';
import RedirectToPlansPage from './../Views/OnboardingVirtualMembers/RedirectToPlansPage';
import { initTracking } from '../../tracking/tracking';
import { getLanguage } from '../../reducers/i18n';
import P from 'prop-types';
import TokenGaurd from '../Auth/TokenGuard';
import { RESIDENT, VIRTUAL } from '../../reducers/currentProgressOnboardingWizard';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.getOrientationClass = this.getOrientationClass.bind(this);
  }

  componentDidMount() {
    initTracking();
  }

  getOrientationClass() {
    return this.props.language.startsWith('he') ? 'rtl' : '';
  }

  render() {
    const className = `main-layout ${this.getOrientationClass()}`;
    return (
      <div className={className}>
        <IconsLibrary />
        <Router>
          <Switch>
            <TokenGaurd onboardingType={RESIDENT} exact path="/" component={OnBoardingWizard} />
            <TokenGaurd onboardingType={VIRTUAL} exact path="/neighbors" component={RedirectToPlansPage} />
            <TokenGaurd onboardingType={VIRTUAL} path="/neighbors/plan/:plan" component={OnBoardingWizardVirtalMembers} />
          </Switch>
        </Router>
      </div>
    );
  }
}

Layout.propTypes = {
  language: P.string
};

const mapStateToProps = state => ({
  language: getLanguage(state)
});

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js